import React from 'react'
import { FormatCurrency } from '../../../utils/FormatCurrency'

interface totalDiscountProps {
    total_discount: number | any
    wallet_amount: number | any

}

export const TotalDiscount = (props: totalDiscountProps) => {
    return (
        <div className='totalDiscount'>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.53 8.87L18.01 7.35001C17.75 7.09 17.54 6.58001 17.54 6.22001V4.06C17.54 3.18 16.82 2.46 15.94 2.46H13.79C13.43 2.46 12.92 2.25 12.66 1.99L11.14 0.470005C10.52 -0.149995 9.5 -0.149995 8.88 0.470005L7.34 1.99C7.09 2.25 6.58 2.46 6.21 2.46H4.06C3.18 2.46 2.46 3.18 2.46 4.06V6.21C2.46 6.57 2.25 7.08 1.99 7.34L0.470005 8.86C-0.149995 9.48 -0.149995 10.5 0.470005 11.12L1.99 12.64C2.25 12.9 2.46 13.41 2.46 13.77V15.92C2.46 16.8 3.18 17.52 4.06 17.52H6.21C6.57 17.52 7.08 17.73 7.34 17.99L8.86 19.51C9.48 20.13 10.5 20.13 11.12 19.51L12.64 17.99C12.9 17.73 13.41 17.52 13.77 17.52H15.92C16.8 17.52 17.52 16.8 17.52 15.92V13.77C17.52 13.41 17.73 12.9 17.99 12.64L19.51 11.12C20.16 10.51 20.16 9.49 19.53 8.87ZM6 7C6 6.45 6.45 6 7 6C7.55 6 8 6.45 8 7C8 7.55 7.56 8 7 8C6.45 8 6 7.55 6 7ZM7.53 13.53C7.38 13.68 7.19 13.75 7 13.75C6.81 13.75 6.62001 13.68 6.47001 13.53C6.18001 13.24 6.18001 12.76 6.47001 12.47L12.47 6.47001C12.76 6.18001 13.24 6.18001 13.53 6.47001C13.82 6.76 13.82 7.24 13.53 7.53L7.53 13.53ZM13 14C12.44 14 11.99 13.55 11.99 13C11.99 12.45 12.44 12 12.99 12C13.54 12 13.99 12.45 13.99 13C13.99 13.55 13.55 14 13 14Z" fill="#3D6AAE" />
            </svg>

            <p>Your total savings with this purchase is worth Rs. {props.total_discount  + props.wallet_amount}</p>
        </div>
    )
}
